import React, { useEffect, useState } from "react";
import { Grid2, Divider, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Counter from "./Counters";
import Stopwatch from "./Stopwatch";
import FreeText from "./FreeText";
import DataList from "./DataList";
import MultiSelectDataList from "./Components/MultiSelectDataList";
import Camera from "./Camera";
import { controlTypes } from "../../../Config/constants";
import { dataService } from "../../../Services/data/data.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotateCcw } from "lucide-react";

import MessageDialog from "../../Shared/Dialogs/MessageDialog";
import { parseNewDateToDDMMYYY, isDateObject } from "../../../Utils/dateHelper";
import Scanner from "./Scanner";

function MeasurementBlocks(props) {
  const classes = useStyles();
  const current = new Date();
  const date = parseNewDateToDDMMYYY(current);

  const [valuesArray, setValuesArray] = useState([]);
  const [confirmDialogOpen, setComfirmDialogOpen] = useState(false);
  const [runningStopwatchDialogOpen, setRunningStopwatchDialogOpen] = useState(false);
  const [watchStillRunningDialogOpen, setWatchStillRunningDialogOpen] = useState(false);
  const [stopwatchOnHold, setStopwatchOnHold] = useState([]);
  const [resetAllExcept, setResetAllExcept] = useState(null); // set to Id of timer you don't want to reset and all others will be reset
  const [stopWatchesRunning, setStopWatchesRunning] = useState([]);
  const [openStopwatchCommentDialog, setOpenStopwatchCommentDialog] = useState(false); // If this is set to true, the stopwatch components that have comment enabled will open the comment dialog (if it's applicable)
  const [refreshStopWatches, setRefreshStopWatches] = useState(false);
  const [refresh, setRefresh] = useState(false);

  // Key
  const [keyError, setKeyError] = useState(false);
  const [currentKey, setCurrentKey] = useState(props.currentKey);

  useEffect(() => {
    let elementsArray = [];
    var i = 0;
    for (i = 0; i < props.data.length; i++) {
      elementsArray.push({
        id: props.data[i].id,
        value: props.data[i].isParent && !refresh ? currentKey : props.data[i].controlTypeId === 3 ? "" : props.data[i].value ? props.data[i].value : "",
        startTime: date,
        running: props.data[i].running,
        controlTypeId: props.data[i].controlTypeId,
        price: props.data[i].price,
        currencyId: props.data[i].currencyId,
        startValue: props.data[i].startValue !== null ? props.data[i].startValue : null,
        stopValue: props.data[i].stopValue !== null ? props.data[i].stopValue : null,
      });
    }
    setValuesArray(elementsArray);
    setRefreshStopWatches(!refreshStopWatches);
    // eslint-disable-next-line
  }, [props.data]);

  useEffect(() => {
    setCurrentKey(props.currentKey);
  }, [props.currentKey]);

  const SendTextValue = (value, detailId) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.FREETEXT;
    tempValues.find((x) => x.id === detailId).value = String(value);
    tempValues.find((x) => x.id === detailId).running = true;

    setValuesArray(tempValues);
    dataService.saveMeasurement(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        var detail = props.data.find((x) => x.id === detailId);
        if (detail.isParent) {
          props.setKeyFound(true);
          props.setCurrentKey(value);
          setText(value, detailId);
          setCurrentKey(value);
        } else {
          setText(null, detailId);
        }
        toast.success("Succesfully saved", { position: toast.POSITION.TOP_CENTER });
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  const setCounter = (value, detailId, isNegative = false) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.COUNTER;
    tempValues.find((x) => x.id === detailId).value = String(value);
    tempValues.find((x) => x.id === detailId).running = true;
    tempValues.find((x) => x.id === detailId).isNegative = isNegative;

    if (tempValues.some((x) => x.id === detailId)) {
      dataService.saveMeasurement(tempValues.find((x) => x.id === detailId)).then((result) => {
        if (result.success === true) {
          setValuesArray(tempValues);
          //toast.success('Measurements were saved successfully.', { position: toast.POSITION.TOP_CENTER });
        } else {
          props.refreshMeasurements(true);
          toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        }
      });
    }
  };

  const setCounterWithComment = (value, detailId, image, text) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.COUNTER;
    tempValues.find((x) => x.id === detailId).value = String(value);
    tempValues.find((x) => x.id === detailId).running = true;
    tempValues.find((x) => x.id === detailId).commentImage = image;
    tempValues.find((x) => x.id === detailId).commentText = text;

    setValuesArray(tempValues);
    dataService.saveMeasurementWithComment(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        //toast.success('Measurements were saved successfully.', { position: toast.POSITION.TOP_CENTER });
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  const setStopWatch = (value, detailId, startTime, endTime, reset) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.STOPWATCH;
    tempValues.find((x) => x.id === detailId).value = String(value);
    if (startTime) {
      tempValues.find((x) => x.id === detailId).stopValue = null;
      tempValues.find((x) => x.id === detailId).running = true;
      setValuesArray(tempValues);

      let startDateString = parseNewDateToDDMMYYY(startTime);
      tempValues.find((x) => x.id === detailId).startValue = startDateString;
    } else {
      if (reset) {
        tempValues.find((x) => x.id === detailId).running = false;
        tempValues.find((x) => x.id === detailId).value = 0;
      } else {
        tempValues.find((x) => x.id === detailId).running = true;
      }

      setValuesArray(tempValues);
      let endDateString = parseNewDateToDDMMYYY(endTime);
      tempValues.find((x) => x.id === detailId).stopValue = endDateString;
    }

    if (reset) {
      if (isDateObject(tempValues.find((x) => x.id === detailId).startValue)) {
        tempValues.find((x) => x.id === detailId).startValue = parseNewDateToDDMMYYY(tempValues.find((x) => x.id === detailId).startValue);
      }
      tempValues.find((x) => x.id === detailId).value = "0";
    }

    if (isDateObject(tempValues.find((x) => x.id === detailId).startValue)) {
      tempValues.find((x) => x.id === detailId).startValue = parseNewDateToDDMMYYY(tempValues.find((x) => x.id === detailId).startValue);
    }

    dataService.saveMeasurement(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        //toast.success('Measurements were saved successfully.', { position: toast.POSITION.TOP_CENTER });
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  const setStopwatchWithComment = (detailId, image, comment) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.STOPWATCH;
    tempValues.find((x) => x.id === detailId).value = String(stopwatchOnHold.value);
    tempValues.find((x) => x.id === detailId).commentImage = image;
    tempValues.find((x) => x.id === detailId).commentText = comment;
    tempValues.find((x) => x.id === detailId).stopValue = null;
    tempValues.find((x) => x.id === detailId).running = true;
    setValuesArray(tempValues);

    let startDateString = parseNewDateToDDMMYYY(stopwatchOnHold.startTime);
    tempValues.find((x) => x.id === detailId).startValue = startDateString;

    dataService.saveMeasurementWithComment(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        setOpenStopwatchCommentDialog(false);
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  const startTimer = (value, detailId, startTime) => {
    setResetAllExcept(null);
    if (stopWatchesRunning.length > 0) {
      setStartValue(value, detailId, startTime);
      setStopwatchOnHold({ value: value, detailId: detailId, startTime: startTime });
      setRunningStopwatchDialogOpen(true);
    } else {
      setStartValue(value, detailId, startTime);
    }
  };

  const startTimerWithComment = (value, detailId, startTime) => {
    setResetAllExcept(null);
    if (stopWatchesRunning.length > 0) {
      setStartValueWithComment(value, detailId, startTime);
      setStopwatchOnHold({ value: value, detailId: detailId, startTime: startTime });
      setRunningStopwatchDialogOpen(true);
    } else {
      setStopwatchOnHold({ value: value, detailId: detailId, startTime: startTime });
      setStartValueWithComment(value, detailId, startTime);
      setOpenStopwatchCommentDialog(true);
    }
  };

  const setStartValue = (value, detailId, startTime) => {
    let tempStopWatchesRunning = [...stopWatchesRunning];
    tempStopWatchesRunning.push(detailId);
    setStopWatchesRunning(tempStopWatchesRunning);
    setStopWatch(value, detailId, startTime, null, false);
  };

  const setStartValueWithComment = (value, detailId, startTime) => {
    let tempStopWatchesRunning = [...stopWatchesRunning];
    tempStopWatchesRunning.push(detailId);
    setStopWatchesRunning(tempStopWatchesRunning);
    // setStopWatchWithComment(value, detailId, startTime, null, false)
  };

  // const addStopwatchCommentAction = (detailId, image, text) => {
  //     dataService.addCommentToStopwatchEntry(detailId, image, text).then(result => {
  //         if (result.succes === true) {
  //             toast.success('Comment added successfully', { position: toast.POSITION.TOP_CENTER });
  //             setOpenStopwatchCommentDialog(false);
  //         } else {
  //             toast.error(result.message, { position: toast.POSITION.TOP_CENTER })
  //         }
  //     })
  // }

  const setStopValue = (value, detailId, endTime, reset) => {
    let tempStopWatchesRunning = [...stopWatchesRunning];
    if (tempStopWatchesRunning.some((x) => x === detailId)) {
      let index = tempStopWatchesRunning.indexOf(tempStopWatchesRunning.find((x) => x === detailId));
      tempStopWatchesRunning.splice(index, 1);
    }
    setStopWatchesRunning(tempStopWatchesRunning);
    setStopWatch(value, detailId, null, endTime, reset);
  };

  const setText = (value, detailId) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.FREETEXT;
    tempValues.find((x) => x.id === detailId).value = value;
    tempValues.find((x) => x.id === detailId).running = false;
    setValuesArray(tempValues);
  };

  const setTextWithComment = (value, detailId, image, text) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.FREETEXT;
    tempValues.find((x) => x.id === detailId).value = String(value);
    tempValues.find((x) => x.id === detailId).running = true;
    tempValues.find((x) => x.id === detailId).commentImage = image;
    tempValues.find((x) => x.id === detailId).commentText = text;

    setValuesArray(tempValues);
    dataService.saveMeasurementWithComment(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        //toast.success('Measurements were saved successfully.', { position: toast.POSITION.TOP_CENTER });
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  const setDataListValue = (DataListValue, detailId) => {
    let tempValues = [...valuesArray];
    tempValues.find((x) => x.id === detailId).controlTypeId = controlTypes.DATALIST;
    tempValues.find((x) => x.id === detailId).value = DataListValue;
    tempValues.find((x) => x.id === detailId).dataListValue = DataListValue;
    tempValues.find((x) => x.id === detailId).running = false;
    setValuesArray(tempValues);

    dataService.saveMeasurement(tempValues.find((x) => x.id === detailId)).then((result) => {
      if (result.success === true) {
        var detail = props.data.find((x) => x.id === detailId);
        if (detail.isParent) {
          props.setKeyFound(true);
        }

        //toast.success('Measurements were saved successfully.', { position: toast.POSITION.TOP_CENTER });
      } else {
        props.refreshMeasurements(true);
        toast.error(result.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
    });
  };

  function elementSwitch(controlTypeId, description, id, color, dataListId, comment, comments, isKey, isMultiSelect) {
    switch (controlTypeId) {
      case controlTypes.COUNTER: //1
        return (
          <React.Fragment>
            {valuesArray.length >= 1 && (
              <Counter
                isKey={isKey}
                currentKey={currentKey}
                keyRequired={props.keyRequired}
                keyFound={props.keyFound}
                refresh={refresh}
                comments={comments}
                comment={comment}
                color={color !== null ? color : "#e6ccb1"}
                textColor={getTextColor(color !== null ? color : "#e6ccb1")}
                darkness={getDarkness(color !== null ? color : "#84ff69")}
                description={description}
                counter={valuesArray.some((x) => x.id === id) ? valuesArray.find((x) => x.id === id).value : null}
                id={id}
                action={setCounter}
                actionWithComment={setCounterWithComment}
              ></Counter>
            )}
          </React.Fragment>
        );
      case controlTypes.STOPWATCH: //2
        return (
          <React.Fragment>
            {valuesArray.length >= 1 && (
              <Stopwatch
                isKey={isKey}
                currentKey={currentKey}
                startActionWithComment={startTimerWithComment}
                keyRequired={props.keyRequired}
                keyFound={props.keyFound}
                comments={comments}
                comment={comment}
                openCommentDialog={openStopwatchCommentDialog}
                addCommentAction={setStopwatchWithComment}
                color={color !== null ? color : "#a5b6d4"}
                textColor={getTextColor(color !== null ? color : "#a5b6d4")}
                description={description}
                resetAllExcept={resetAllExcept}
                refresh={refreshStopWatches}
                darkness={getDarkness(color !== null ? color : "#84ff69")}
                stopwatch={valuesArray.some((x) => x.id === id) ? valuesArray.find((x) => x.id === id) : null}
                startAction={startTimer}
                stopAction={setStopValue}
                id={id}
              ></Stopwatch>
            )}
          </React.Fragment>
        );
      case controlTypes.FREETEXT: //3
        return (
          <React.Fragment>
            {valuesArray.length >= 1 && (
              <FreeText
                isKey={isKey}
                currentKey={currentKey}
                keyRequired={props.keyRequired}
                keyFound={props.keyFound}
                color={color !== null ? color : "#cae6cb"}
                textColor={getTextColor(color !== null ? color : "#cae6cb")}
                description={description}
                text={valuesArray.some((x) => x.id === id) ? valuesArray.find((x) => x.id === id).value : null}
                darkness={getDarkness(color !== null ? color : "#84ff69")}
                id={id}
                setText={setText}
                action={SendTextValue}
              ></FreeText>
            )}
          </React.Fragment>
        );
      case controlTypes.DATALIST: //4
        if (isMultiSelect) {
          return (
            <React.Fragment>
              {valuesArray.length >= 1 && (
                <MultiSelectDataList
                  isKey={isKey}
                  currentKey={currentKey}
                  keyRequired={props.keyRequired}
                  keyFound={props.keyFound}
                  refresh={refresh}
                  color={color !== null ? color : "#de576d"}
                  textColor={getTextColor(color !== null ? color : "#de576d")}
                  dataListId={dataListId}
                  projectGuid={props.projectGuid}
                  description={description}
                  darkness={getDarkness(color !== null ? color : "#84ff69")}
                  id={id}
                  setDataValue={setDataListValue}
                ></MultiSelectDataList>
              )}
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment>
              {valuesArray.length >= 1 && (
                <DataList
                  isKey={isKey}
                  currentKey={currentKey}
                  keyRequired={props.keyRequired}
                  keyFound={props.keyFound}
                  refresh={refresh}
                  color={color !== null ? color : "#de576d"}
                  textColor={getTextColor(color !== null ? color : "#de576d")}
                  dataListId={dataListId}
                  projectGuid={props.projectGuid}
                  description={description}
                  darkness={getDarkness(color !== null ? color : "#84ff69")}
                  id={id}
                  setDataValue={setDataListValue}
                ></DataList>
              )}
            </React.Fragment>
          );
        }
      case controlTypes.SCANNER: //5
        return (
          <React.Fragment>
            {valuesArray.length >= 1 && (
              <Scanner
                isKey={isKey}
                currentKey={currentKey}
                keyRequired={props.keyRequired}
                keyFound={props.keyFound}
                comments={comments}
                comment={comment}
                refresh={refresh}
                color={color !== null ? color : "#cae6cb"}
                textColor={getTextColor(color !== null ? color : "#cae6cb")}
                darkness={getDarkness(color !== null ? color : "#84ff69")}
                description={description}
                id={id}
                action={SendTextValue}
                actionWithComment={setTextWithComment}
              ></Scanner>
            )}
          </React.Fragment>
        );
      case controlTypes.CAMERA: //6
        return (
          <React.Fragment>
            {valuesArray.length >= 1 && (
              <Camera
                isKey={isKey}
                currentKey={currentKey}
                keyRequired={props.keyRequired}
                keyFound={props.keyFound}
                refresh={refresh}
                toggleRefresh={props.toggleRefresh}
                comments={comments}
                comment={comment}
                color={color !== null ? color : "#84ff69"}
                textColor={getTextColor(color !== null ? color : "#84ff69")}
                darkness={getDarkness(color !== null ? color : "#84ff69")}
                description={description}
                id={id}
              ></Camera>
            )}
          </React.Fragment>
        );
      case controlTypes.EXTERNALAPI: //7
        return false;

      default:
        return <React.Fragment> </React.Fragment>;
    }
  }

  const resetAndSave = () => {
    setRefresh(!refresh);
    var measurements = [];
    valuesArray.forEach((x) =>
      measurements.push({
        ProjectDetailId: x.id,
        StartTime: x.startTime,
        // Value: x.isParent ? "" : String(x.value),
        Value: props.data.find((d) => d.id === x.id).isParent ? "" : x.value !== null ? String(x.value) : "",
        StartValue: x.startValue ? parseNewDateToDDMMYYY(new Date(x.startValue)) : null,
        StopValue: x.stopValue ? parseNewDateToDDMMYYY(new Date(x.stopValue)) : null,
        DataListValue: String(x.dataListValue),
        Running: x.running,
        controlTypeId: x.controlTypeId,
        currencyId: x.currencyId,
        Description: "",
      })
    );
    props.setCurrentKey(null);
    dataService.saveAndResetMeasurements(measurements).then((result) => {
      closeConfirmDialog();
      props.refreshMeasurements();
    });
  };

  const openConfirmDialog = () => {
    if (stopWatchesRunning.length > 0) {
      openWatchStillRunningDialog();
    } else {
      setComfirmDialogOpen(true);
    }
  };

  const closeConfirmDialog = () => {
    setComfirmDialogOpen(false);
  };

  const closeWatchStillRunningDialog = () => {
    setWatchStillRunningDialogOpen(false);
  };

  const openWatchStillRunningDialog = () => {
    setWatchStillRunningDialogOpen(true);
  };

  const measurementGrid = {
    marginTop: "25px",
  };

  function getRGB(c) {
    return parseInt(c, 16) || c;
  }

  function getsRGB(c) {
    return getRGB(c) / 255 <= 0.03928 ? getRGB(c) / 255 / 12.92 : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4);
  }

  function getLuminance(hexColor) {
    if (hexColor.includes("#")) {
      return 0.2126 * getsRGB(hexColor.substr(1, 2)) + 0.7152 * getsRGB(hexColor.substr(3, 2)) + 0.0722 * getsRGB(hexColor.substr(-2));
    } else {
      return 0.2126 * hexColor + 0.7152 * hexColor + 0.0722 * hexColor;
    }
  }

  function getContrast(f, b) {
    const L1 = getLuminance(f);
    const L2 = getLuminance(b);
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
  }

  function getTextColor(bgColor) {
    if (bgColor === null) {
      return "#ffffff";
    } else {
      const whiteContrast = getContrast(bgColor, "#ffffff");
      const blackContrast = getContrast(bgColor, "#000000");
      return whiteContrast > blackContrast ? "#ffffff" : "#000000";
    }
  }

  function getDarkness(bgColor) {
    if (bgColor === null) {
      return "#ffffff";
    } else {
      const whiteContrast = getContrast(bgColor, "#ffffff");
      const blackContrast = getContrast(bgColor, "#000000");
      return whiteContrast > blackContrast;
    }
  }

  const handlePauseAllOtherTimers = () => {
    setResetAllExcept(stopwatchOnHold.detailId);
    setRunningStopwatchDialogOpen(false);
    if (props.data.find((x) => x.id === stopwatchOnHold.detailId).hasComment) {
      setOpenStopwatchCommentDialog(true);
    }
  };

  const keepTimersRunning = () => {
    setRunningStopwatchDialogOpen(false);
    setOpenStopwatchCommentDialog(true);
  };

  return (
    <div>
      <Grid2 container direction="row" justifyContent="center" spacing={3} alignItems="center" style={measurementGrid}>
        {props.data
          .filter((x) => x.controlTypeId !== controlTypes.EXTERNALAPI && x.isParent)
          .map((x) => (
            <Grid2 key={x.id} item size={props.view}>
              {elementSwitch(x.controlTypeId, x.description, x.id, x.color, x.dataListId, x.hasComment, x.comments ? x.comments : "", true, x.isMultiSelect)}
            </Grid2>
          ))}

        {props.data
          .filter((x) => x.controlTypeId !== controlTypes.EXTERNALAPI && !x.isParent)
          .map((x) => (
            <Grid2 key={x.id} item size={props.view}>
              {elementSwitch(x.controlTypeId, x.description, x.id, x.color, x.dataListId, x.hasComment, x.comments ? x.comments : "", false, x.isMultiSelect)}
            </Grid2>
          ))}
      </Grid2>
      <Divider style={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}></Divider>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
        <Button
          onClick={() => openConfirmDialog()}
          variant="contained"
          startIcon={<RotateCcw />}
          sx={{ background: "#C3996B !important", color: "white !important", padding: "10px !important", borderRadius: "4px !important" }}
        >
          New registration
        </Button>
      </Box>
      {confirmDialogOpen && (
        <MessageDialog
          dialogOpen={confirmDialogOpen}
          closeDialog={closeConfirmDialog}
          messageTitle={"New registration?"}
          action={resetAndSave}
          messageContent={"Running measurements will be stopped and you'll be able to start new measurements."}
          buttonText={"OK"}
          button2Text={"Cancel"}
        ></MessageDialog>
      )}
      {watchStillRunningDialogOpen && (
        <MessageDialog
          dialogOpen={watchStillRunningDialogOpen}
          closeDialog={closeWatchStillRunningDialog}
          action={closeWatchStillRunningDialog}
          messageTitle={"Attention!"}
          buttonCount={1}
          messageContent={"There are still stopwatches running... Please pause/reset the watches first before initiating new measurements."}
          buttonText={"OK"}
        ></MessageDialog>
      )}
      {/* {runningStopwatchDialogOpen && */}
      <Dialog open={runningStopwatchDialogOpen} classes={{ paper: classes.dialogPaper }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <div className={classes.dialog__head}>
          <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
            Pause other timers?
          </DialogTitle>
        </div>
        <DialogContent className={classes.dialog__contentContainer}>
          <div className={classes.dialog__content}>
            <p className={classes.dialog__subtitle}>You are trying to start a new timer while there are other timers running. Do you want to pause the other timers?</p>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialog__buttonContainer}>
          <button className={classes.dialog__button__secondary} onClick={() => handlePauseAllOtherTimers()}>
            Pause other timers
          </button>
          <button className={classes.dialog__button} onClick={() => keepTimersRunning()}>
            Keep timers running
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MeasurementBlocks;

const useStyles = makeStyles(() => ({
  dialogPaper: {
    width: "400px !important",
    height: "auto",
    borderRadius: "6px !important",
  },

  dialog__head: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",

    padding: "16px 16px 0px 16px !important",
    marginBottom: "8px !important",
  },

  dialog__title: {
    fontSize: "24px !important",
    fontFamily: "Lato, sans-serif !important",
    fontWeight: "normal",

    padding: "0px !important",
  },

  dialog__contentContainer: {
    padding: "0px 16px !important",
    paddingBottom: "16px !important",

    // remove scrollbar
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },

  dialog__content: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",

    margin: "0px !important",
  },

  dialog__subtitle: {
    fontSize: "16px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "normal",

    color: "#0C0E29",

    margin: "0px",
  },

  dialog__buttonContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "space-between !important",
    width: "100% !important",
    boxSizing: "border-box",

    padding: "16px !important",
    paddingTop: "0px !important",
    margin: "0px !important",
  },

  dialog__button: {
    height: "40px",
    width: "50%",
    padding: "0 16px",

    border: "none",
    borderRadius: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "16px",

    color: "white",
    backgroundColor: "#C3996B",

    userSelect: "none",

    // align right
    marginLeft: "auto !important",

    "&:hover": {
      backgroundColor: "#a77d4f",
      cursor: "pointer",
    },
    "&:disabled": {
      backgroundColor: "lightgrey !important",
      color: "white !important",
      border: "1px solid darkgrey !important",
      cursor: "not-allowed !important",
    },
  },

  dialog__button__secondary: {
    height: "40px",
    width: "50%",
    padding: "0 16px",
    verticalAlign: "center",
    border: "1px solid #D84949",
    borderRadius: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "#D84949",
    backgroundColor: "transparent",

    transition: "all 0.2s ease-in-out",

    userSelect: "none",

    "&:hover": {
      backgroundColor: "#C73B3B",
      color: "white",
      border: "1px solid #C73B3B",
      cursor: "pointer",
    },
    "&:disabled": {
      backgroundColor: "lightgrey !important",
      color: "white !important",
      border: "1px solid darkgrey !important",
      cursor: "not-allowed !important",
    },
  },
}));
